import gql from 'graphql-tag';

export const GET_SUCCESS_PLAN_QUERY = gql`
  query getSuccessPlan($id: Int!) {
    plan(id: $id) {
      id
      status
      name
      utilityAccounts {
        id
      }
    }
  }
`;

export const getSuccessPlanMock = {
  plan: {
    __typename: 'Plan',
    id: 20,
    name: 'accountNickname',
    utilityAccounts: [{ id: 1 }],
    status: 'active',
  },
};
